// extracted by mini-css-extract-plugin
export default {"infoBlock":"info-block_infoBlock__AJQSw","icon":"info-block_icon__WhUy6","text":"info-block_text__FHDV-"};